/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp, Play, Pause, Square, ListOrdered } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "./adminShared";

export const ControlTab = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    handleShowTop6, handleHideTop6, top6OverlayVisible,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries, handleUnapplyAllVotes,
  } = useAdmin();
  const [showUnapplyConfirm, setShowUnapplyConfirm] = React.useState(false);
  const [autoRunning, setAutoRunning] = React.useState(false);
  const [autoPaused, setAutoPaused] = React.useState(false);
  const [autoProgress, setAutoProgress] = React.useState(null);
  const [autoDelayShow, setAutoDelayShow] = React.useState(() => parseInt(localStorage.getItem('auto_delay_show') || '10', 10));
  const [autoDelayReveal, setAutoDelayReveal] = React.useState(() => parseInt(localStorage.getItem('auto_delay_reveal') || '8', 10));
  const autoStopRef = React.useRef(false);
  const autoPauseRef = React.useRef(false);

  const autoSleep = async (seconds) => {
    let elapsed = 0;
    while (elapsed < seconds * 1000) {
      if (autoStopRef.current) throw new Error('auto-stopped');
      if (!autoPauseRef.current) elapsed += 250;
      await new Promise(r => setTimeout(r, 250));
    }
  };

  const startAutoPresentation = async () => {
    const juryIds = new Set(countries.filter(c => c.is_jury).map(c => c.id));
    const pending = [
      ...votes.filter(v => !v.applied && juryIds.has(v.from_country_id)),
      ...votes.filter(v => !v.applied && !juryIds.has(v.from_country_id)),
    ];
    if (pending.length === 0) {
      toast.info("No hay votos pendientes de presentar");
      return;
    }
    localStorage.setItem('auto_delay_show', String(autoDelayShow));
    localStorage.setItem('auto_delay_reveal', String(autoDelayReveal));
    autoStopRef.current = false;
    autoPauseRef.current = false;
    setAutoRunning(true);
    setAutoPaused(false);
    try {
      for (let i = 0; i < pending.length; i++) {
        const v = pending[i];
        setAutoProgress({ index: i + 1, total: pending.length, name: v.from_country_name, phase: 'Mostrando votos' });
        await axios.post(`${API}/admin/current-voter`, { country_id: v.from_country_id });
        await autoSleep(autoDelayShow);
        setAutoProgress({ index: i + 1, total: pending.length, name: v.from_country_name, phase: 'Revelando puntos ocultos' });
        await axios.post(`${API}/admin/reveal-12-points`);
        await autoSleep(autoDelayReveal);
        setAutoProgress({ index: i + 1, total: pending.length, name: v.from_country_name, phase: 'Sumando puntos' });
        await axios.post(`${API}/admin/apply-votes/${v.from_country_id}`);
        fetchVotes();
        await autoSleep(2);
      }
      toast.success("Auto-presentación completada");
    } catch (e) {
      if (e.message === 'auto-stopped') toast.info("Auto-presentación detenida");
      else toast.error("Error en la auto-presentación");
    } finally {
      autoStopRef.current = false;
      autoPauseRef.current = false;
      setAutoRunning(false);
      setAutoPaused(false);
      setAutoProgress(null);
      fetchVotes();
    }
  };

  const toggleAutoPause = () => {
    autoPauseRef.current = !autoPauseRef.current;
    setAutoPaused(autoPauseRef.current);
  };

  const stopAutoPresentation = () => {
    autoStopRef.current = true;
  };

  return (
          <TabsContent value="control" className="space-y-4 mt-6">
            <Card className="bg-zinc-900/80 border-zinc-800 p-6">
              <h2 className="font-unbounded text-xl text-white mb-4">Control de Pantalla Pública</h2>
              <p className="text-zinc-400 mb-6">Muestra los votos en pantalla y súmalos cuando estés listo</p>

              {/* Auto-Presentación */}
              <div className="mb-6 p-4 bg-gradient-to-br from-purple-900/20 to-cyan-900/20 border border-cyan-700/40 rounded-lg space-y-3" data-testid="auto-presentation-panel">
                <div className="flex items-center gap-2">
                  <Play className="w-5 h-5 text-cyan-400" />
                  <h3 className="text-cyan-300 font-bold uppercase tracking-wider text-sm">Auto-Presentación</h3>
                </div>
                <p className="text-zinc-400 text-xs">Recorre automáticamente los votantes pendientes en orden: muestra sus votos, revela los puntos ocultos y los suma al marcador.</p>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <Label className="text-zinc-400 text-xs">Segundos mostrando votos</Label>
                    <Input
                      type="number"
                      min="2"
                      max="120"
                      data-testid="input-auto-delay-show"
                      value={autoDelayShow}
                      disabled={autoRunning}
                      onChange={(e) => setAutoDelayShow(Math.max(2, parseInt(e.target.value, 10) || 2))}
                      className="bg-zinc-800 border-zinc-700 text-white"
                    />
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs">Segundos tras revelar</Label>
                    <Input
                      type="number"
                      min="2"
                      max="120"
                      data-testid="input-auto-delay-reveal"
                      value={autoDelayReveal}
                      disabled={autoRunning}
                      onChange={(e) => setAutoDelayReveal(Math.max(2, parseInt(e.target.value, 10) || 2))}
                      className="bg-zinc-800 border-zinc-700 text-white"
                    />
                  </div>
                </div>
                {!autoRunning ? (
                  <Button
                    type="button"
                    onClick={startAutoPresentation}
                    className="w-full bg-cyan-600 hover:bg-cyan-500 text-white font-semibold"
                    data-testid="btn-start-auto"
                  >
                    <Play className="w-4 h-4 mr-2" />
                    Iniciar Auto-Presentación ({votes.filter(v => !v.applied).length} pendientes)
                  </Button>
                ) : (
                  <div className="space-y-2">
                    {autoProgress && (
                      <div className="bg-zinc-900/70 border border-zinc-700 rounded-md p-3 text-center" data-testid="auto-progress">
                        <p className="text-white font-semibold text-sm">
                          {autoProgress.index}/{autoProgress.total} · {autoProgress.name}
                        </p>
                        <p className="text-cyan-400 text-xs mt-1">{autoPaused ? 'EN PAUSA' : autoProgress.phase}</p>
                      </div>
                    )}
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        type="button"
                        onClick={toggleAutoPause}
                        className={autoPaused ? "bg-green-600 hover:bg-green-500 text-white" : "bg-yellow-600 hover:bg-yellow-500 text-white"}
                        data-testid="btn-pause-auto"
                      >
                        {autoPaused ? <><Play className="w-4 h-4 mr-2" />Reanudar</> : <><Pause className="w-4 h-4 mr-2" />Pausar</>}
                      </Button>
                      <Button
                        type="button"
                        onClick={stopAutoPresentation}
                        className="bg-red-600 hover:bg-red-500 text-white"
                        data-testid="btn-stop-auto"
                      >
                        <Square className="w-4 h-4 mr-2" />
                        Detener
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              {/* Des-sumar votos: vuelve el marcador a cero sin borrar los votos recibidos */}
              <div className="mb-6">
                <Button
                  type="button"
                  onClick={() => setShowUnapplyConfirm(true)}
                  className="w-full bg-orange-600 hover:bg-orange-500 text-white font-semibold"
                  data-testid="btn-unapply-all-votes"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Des-sumar votos
                </Button>
                <p className="text-zinc-500 text-xs mt-2 text-center">
                  Pone el marcador a cero como al inicio (todos los países a 0 y casilla &quot;Sumados&quot; desmarcada). NO borra los votos recibidos.
                </p>
              </div>

              <AlertDialog open={showUnapplyConfirm} onOpenChange={setShowUnapplyConfirm}>
                <AlertDialogContent className="bg-zinc-900 border-zinc-700" data-testid="unapply-confirm-dialog">
                  <AlertDialogHeader>
                    <AlertDialogTitle className="text-white">¿Des-sumar todos los votos?</AlertDialogTitle>
                    <AlertDialogDescription className="text-zinc-400">
                      El marcador volverá a cero (todos los países a 0) y se desmarcará la casilla &quot;Sumados&quot; de cada país/jurado, para poder empezar la votación de nuevo.
                      <br /><br />
                      <span className="text-green-400 font-semibold">Los votos recibidos NO se borran</span> — solo se deja de contarlos hasta que vuelvas a pulsar &quot;Sumar&quot;.
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700" data-testid="btn-cancel-unapply">Cancelar</AlertDialogCancel>
                    <AlertDialogAction
                      onClick={() => handleUnapplyAllVotes()}
                      className="bg-orange-600 hover:bg-orange-500 text-white"
                      data-testid="btn-confirm-unapply"
                    >
                      Sí, des-sumar
                    </AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>

              {/* Winner Overlay Quick Actions */}
              <div className="mb-6 p-4 bg-gradient-to-br from-yellow-900/20 to-pink-900/20 border border-yellow-700/40 rounded-lg space-y-3" data-testid="winner-overlay-controls">
                <div className="flex items-center gap-2 mb-1">
                  <Trophy className="w-5 h-5 text-yellow-400" />
                  <h3 className="text-yellow-300 font-bold uppercase tracking-wider text-sm">Overlay de Ganador</h3>
                </div>
                <p className="text-zinc-400 text-xs">Muestra una pantalla de enhorabuena al país ganador. Por defecto coge automáticamente al país en 1ª posición, pero puedes elegir manualmente cualquier otro.</p>
                <div className="grid md:grid-cols-3 gap-2">
                  <Button
                    type="button"
                    onClick={() => handleShowWinner(null)}
                    className="bg-yellow-600 hover:bg-yellow-500 text-white col-span-1"
                    data-testid="btn-show-winner-auto"
                  >
                    <Trophy className="w-4 h-4 mr-2" />
                    Mostrar Ganador (1º)
                  </Button>
                  <select
                    value={winnerPreviewId}
                    onChange={(e) => setWinnerPreviewId(e.target.value)}
                    className="bg-zinc-800 border border-zinc-700 text-white text-sm rounded-md px-2 py-2 col-span-1"
                    data-testid="select-winner-manual"
                  >
                    <option value="">— Seleccionar país manual —</option>
                    {countries.filter(c => !c.is_jury).map(c => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </select>
                  <Button
                    type="button"
                    onClick={() => {
                      if (!winnerPreviewId) {
                        toast.error("Selecciona un país primero");
                        return;
                      }
                      handleShowWinner(winnerPreviewId);
                    }}
                    className="bg-pink-600 hover:bg-pink-500 text-white col-span-1"
                    data-testid="btn-show-winner-manual"
                  >
                    Mostrar Elegido
                  </Button>
                </div>
                {winnerOverlayVisible && (
                  <Button
                    type="button"
                    onClick={handleHideWinner}
                    className="w-full bg-red-600 hover:bg-red-500 text-white"
                    data-testid="btn-hide-winner-overlay"
                  >
                    Ocultar Overlay del Ganador
                  </Button>
                )}
              </div>

              {/* Top 6 Overlay Quick Actions */}
              <div className="mb-6 p-4 bg-gradient-to-br from-emerald-900/20 to-cyan-900/20 border border-emerald-700/40 rounded-lg space-y-3" data-testid="top6-overlay-controls">
                <div className="flex items-center gap-2 mb-1">
                  <ListOrdered className="w-5 h-5 text-emerald-400" />
                  <h3 className="text-emerald-300 font-bold uppercase tracking-wider text-sm">Top 6 Actual</h3>
                </div>
                <p className="text-zinc-400 text-xs">Revela el top 6 provisional en el visualizador, ideal a mitad de las votaciones. Las posiciones aparecen de la 6ª a la 1ª.</p>
                <div className="grid grid-cols-2 gap-2">
                  <Button
                    type="button"
                    onClick={handleShowTop6}
                    className="bg-emerald-600 hover:bg-emerald-500 text-white font-semibold"
                    data-testid="btn-show-top6"
                  >
                    <ListOrdered className="w-4 h-4 mr-2" />
                    Mostrar Top 6
                  </Button>
                  <Button
                    type="button"
                    onClick={handleHideTop6}
                    className="bg-red-600 hover:bg-red-500 text-white"
                    data-testid="btn-hide-top6"
                  >
                    Ocultar Top 6
                  </Button>
                </div>
              </div>
              
              <div className="space-y-4">
                {votes.length > 0 && (() => {
                  const juryIds = new Set(countries.filter(c => c.is_jury).map(c => c.id));
                  const juryVotes = votes.filter(v => juryIds.has(v.from_country_id));
                  const countryVotes = votes.filter(v => !juryIds.has(v.from_country_id));

                  const renderControlCard = (vote) => {
                    const country = countries.find(c => c.id === vote.from_country_id);
                    const isApplied = vote.applied;
                    return (
                      <Card 
                        key={vote.id} 
                        className={`p-4 border transition-colors ${
                          isApplied 
                            ? 'bg-green-900/20 border-green-800' 
                            : 'bg-zinc-800/50 border-zinc-700'
                        }`}
                        data-testid={`vote-card-${vote.from_country_id}`}
                      >
                        <div className="space-y-3">
                          <div className="flex items-center gap-4">
                            <img 
                              src={resolveUrl(country?.flag_url)} 
                              alt={vote.from_country_name}
                              className="w-16 h-12 object-contain"
                              onError={(e) => e.target.src = 'https://placehold.co/80x60/000/FFF?text=Flag'}
                            />
                            <div className="flex-1">
                              <h3 className="font-unbounded text-white font-semibold">{vote.from_country_name}</h3>
                              <p className={`text-sm font-medium ${isApplied ? 'text-green-400' : 'text-zinc-500'}`}>
                                {isApplied ? '✓ Puntos sumados' : 'Pendiente de sumar'}
                              </p>
                            </div>
                          </div>
                          
                          <div className="flex gap-2">
                            <Button
                              data-testid={`btn-show-${vote.from_country_id}`}
                              onClick={() => handleSetCurrentVoter(vote.from_country_id, vote.from_country_name)}
                              variant="outline"
                              className="flex-1 bg-zinc-900 border-zinc-700 hover:bg-zinc-800 text-white"
                            >
                              <Eye className="w-4 h-4 mr-2" />
                              Mostrar
                            </Button>
                            
                            <Button
                              data-testid={`btn-reveal12-${vote.from_country_id}`}
                              onClick={() => handleReveal12Points(vote.from_country_name)}
                              variant="outline"
                              className="flex-1 bg-yellow-900/30 border-yellow-700 hover:bg-yellow-900/50 text-yellow-300"
                            >
                              <Sparkles className="w-4 h-4 mr-2" />
                              12 Pts
                            </Button>
                            
                            <Button
                              data-testid={`btn-apply-${vote.from_country_id}`}
                              onClick={() => handleApplyVotes(vote.from_country_id, vote.from_country_name)}
                              disabled={isApplied}
                              className={`flex-1 ${
                                isApplied 
                                  ? 'bg-green-900/50 text-green-400 cursor-not-allowed' 
                                  : 'bg-pink-600 hover:bg-pink-500 text-white'
                              }`}
                            >
                              {isApplied ? '✓ Sumados' : '+ Sumar'}
                            </Button>
                          </div>
                        </div>
                      </Card>
                    );
                  };

                  return (
                    <div className="space-y-8">
                      {juryVotes.length > 0 && (
                        <div className="space-y-3" data-testid="control-votes-jury-block">
                          <div className="flex items-center gap-3 pb-2 border-b border-zinc-800">
                            <div className="w-1 h-6 bg-yellow-500 rounded-full" />
                            <h3 className="font-unbounded text-yellow-400 text-lg uppercase tracking-wider">Jurado</h3>
                            <span className="text-zinc-500 text-sm">({juryVotes.length})</span>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4">
                            {juryVotes.map(renderControlCard)}
                          </div>
                        </div>
                      )}
                      {countryVotes.length > 0 && (
                        <div className="space-y-3" data-testid="control-votes-countries-block">
                          <div className="flex items-center gap-3 pb-2 border-b border-zinc-800">
                            <div className="w-1 h-6 bg-pink-500 rounded-full" />
                            <h3 className="font-unbounded text-pink-400 text-lg uppercase tracking-wider">Países</h3>
                            <span className="text-zinc-500 text-sm">({countryVotes.length})</span>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4">
                            {countryVotes.map(renderControlCard)}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}
                
                {votes.length === 0 && (
                  <div className="text-center py-8">
                    <EyeOff className="w-12 h-12 text-zinc-700 mx-auto mb-3" />
                    <p className="text-zinc-500">No hay votos para mostrar aún</p>
                  </div>
                )}

                <div className="pt-4 border-t border-zinc-800">
                  <p className="text-zinc-500 text-sm">Estados de votación:</p>
                  <div className="grid md:grid-cols-3 gap-4 mt-3">
                    <div className="bg-green-900/20 border border-green-800 rounded-lg p-3">
                      <p className="text-green-400 text-sm font-semibold">Han votado: {votes.length}</p>
                    </div>
                    <div className="bg-yellow-900/20 border border-yellow-800 rounded-lg p-3">
                      <p className="text-yellow-400 text-sm font-semibold">Pendientes: {votingCountries.length - votes.length}</p>
                    </div>
                    <div className="bg-cyan-900/20 border border-cyan-800 rounded-lg p-3">
                      <p className="text-cyan-400 text-sm font-semibold">Jurado: {juryMembers.length}</p>
                    </div>
                  </div>
                </div>

                {/* Exportar Resultados */}
                <div className="pt-4 border-t border-zinc-800">
                  <p className="text-zinc-500 text-sm mb-3">Exportar resultados cuando hayas terminado:</p>
                  <Button
                    data-testid="btn-export-pdf"
                    onClick={handleExportPdf}
                    disabled={exportingPdf}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    {exportingPdf ? (
                      <>
                        <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                        Generando PDF...
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4 mr-2" />
                        Exportar Resultados a PDF
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </Card>
          </TabsContent>
  );
};
